import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48774a02"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookBrochureware: require('/home/runner/work/platform/platform/packages/client/src/components/elements/book/book-brochureware/BookBrochureware.vue').default})
